import { render, staticRenderFns } from "./BookingQuestions.vue?vue&type=template&id=128d0d01"
import script from "./BookingQuestions.vue?vue&type=script&lang=js"
export * from "./BookingQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports